import Ext from "Ext"
import messageResource from "../../../messageResource";
import {escapeHtmlSymbols} from "../../../atUtils";

const SelectionHelper = function(config) {
    Ext.apply(this, config);
};

SelectionHelper.prototype = {
    /**
     * @cfg {String} itemNounSingularKey item noun singular form message key (required).
     */
    itemNounSingularKey: null,

    /**
     * @cfg {String} itemNounSingularKey item noun plural form message key (required).
     */
    itemNounPluralKey: null,

    /**
     * @cfr {String} itemInactiveMessageKey item inactive message key for list description
     */
    itemInactiveMessageKey: "usersselector.users.disabled",

    /**
     * @cfg {String} noItemsSelectedKey no items selected message key (required).
     */
    noItemsSelectedKey: null,

    /**
     * @cfg {String} true to include inactive items count.
     */
    showInactiveCount: true,


    /**
     * @cfg {String} prefix text prefix.
     */
    prefix: "",

    /**
     * @cfg {String} suffix text suffix.
     */
    suffix: "",

    /**
     * @cfg {Boolean} showSingleItemInactiveText true to show "inactive" text with one item.
     */
    showSingleItemInactiveText: true,

    /**
     * @cfg {Boolean} useNameForSingleItem true to display item name for single item.
     */
    useNameForSingleItem: true,

    /**
     * @cfg {String} inactiveSingleItemTextKey single disabled item text message key.
     */
    inactiveSingleItemTextKey: "common.archived",

    /**
     * @cfg {Number} listDescriptionItemsAmount amount of items to be in list description
     */
    listDescriptionItemsAmount: 15,

    /**
     * @cfg {String} moreListDescriptionItemsMessageKey last row list description message key. To show
     * if more items selected then <code>listDescriptionItemsAmount</code> specifies
     */
    moreListDescriptionItemsMessageKey: "common.more_items",

    /**
     * @cfg {AT.GenericSelectorTreePropertiesController} propertiesController controller used
     * to extract tree item properties
     */
    propertiesController: null,

    /**
     * Returns formatted string that describes the list of items.
     * @param {Array} items list of items with properties {@link #itemNameProperty} and {@link #itemActiveProperty}.
     */
    getDescription: function(items) {
        var result = "";

        if (items.length == 0) {
            return this.getMessage(this.noItemsSelectedKey);
        } else if (items.length == 1 && this.useNameForSingleItem) {
            result = this.getSingleItemText(items[0]);
        } else {
            var itemNoun, inactiveText = "";

            if (items.length == 1) {
                itemNoun = this.getMessage(this.itemNounSingularKey);
                inactiveText = this.propertiesController.isActive(items[0]) ? "" :
                               " " + this.getMessage(this.inactiveSingleItemTextKey);
            } else {
                itemNoun = this.getMessage(this.itemNounPluralKey);
            }

            result = items.length + " ";
            if (!Ext.isEmpty(this.prefix)) {
                result += this.prefix + " ";
            }
            result += itemNoun + inactiveText;
        }

        return result + (this.suffix ? " " + this.suffix : "");
    },

    /**
     * Formats text for single item.
     * @returns {String} formatted string.
     */
    getSingleItemText: function (item) {
        var text = "";
        if (!Ext.isEmpty(this.prefix)) {
            text += this.prefix + " ";
        }
        var nounMsg = this.getMessage(this.itemNounSingularKey);
        if (!Ext.isEmpty(nounMsg)) {
            text += nounMsg + " ";
        }

        text += this.getItemName(item);

        if (this.showSingleItemInactiveText && !this.propertiesController.isActive(item))
            text += " " + this.getMessage(this.inactiveSingleItemTextKey);

        return text;
    },

    getItemName: function(item) {
            return  escapeHtmlSymbols( this.propertiesController.getName(item) );
    },

    getMessage: function(key, args) {
        return messageResource.getEscapedMessage(key, args);
    },

    /**
     * Returns list of string based on passed list of items.
     */
    getListDescription : function ( items, oneItemCallback, sortCallback, itemPluralForm )
    {
        if (items.length == 0)
            return this.getMessage(this.noItemsSelectedKey);

        if (sortCallback) {
            items.sort(sortCallback);
        }
        var result = "";
        var displayAmount = this.listDescriptionItemsAmount >= items.length - 1 ?
                            items.length : this.listDescriptionItemsAmount;

        var lastRow = null;
        if (displayAmount != items.length)
        {
            if (!itemPluralForm)
            {
                itemPluralForm = this.getMessage(this.itemNounPluralKey);
            }
            lastRow = "\n" + this.getMessage( this.moreListDescriptionItemsMessageKey,
                                                 [ items.length - displayAmount, itemPluralForm] );
        }
        for( var i = 0; i < displayAmount; i++ )
        {
            result += oneItemCallback(items[i]);
            if( i != (displayAmount - 1) )
                result += "\n";
        }
        return lastRow ? result + lastRow : result;
    },

    /**
     * Return singel item string representation to display in list description
     * @param item
     */
    getListDescriptionItem : function ( item )
    {
        var result = "";
        result += this.propertiesController.getName(item);

        if ( !this.propertiesController.isActive(item) )
            result += " " + this.getMessage(this.itemInactiveMessageKey);

        return result;
    }
};

export default SelectionHelper;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/selectionHelpers/at_selection_helper.js